<template>
  <v-container>
    <v-layout justify-center align-start v-if="Object.keys(data).length === 0" class="printNone pa-5">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
          <div class="title pa-3">{{ $t('no_account_selected') }}</div>
          <v-layout row wrap pt-2 justify-center class="pa-5">
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="data !== {} && Object.keys(data).length !== 0" row wrap class="pa-5">
      <v-layout id="printLayout" justify-center row wrap>
        <v-layout row style="text-align: center; margin-top: 5em;" class="printShow">
          <v-layout column style="margin-right: -2em;">
            <span><img src="img/mpt.gif" alt="MPT Logo" height="65" width="62"></span>
            <span>MAJLIS PERBANDARAN TAWAU</span>
            <span>Peti Surat 412, Jalan Dunlop, 91007 Tawau, Sabah</span>
            <span>Tel: 089-701698, Fax: 089-701631</span>
          </v-layout>
          <qrcode-vue :value="url" size="80" level="H" style="text-align: right; margin-top: -6em;"></qrcode-vue>
        </v-layout>
        <v-flex xs12 sm6 class="property_info">
          <h3 class="printShow" style="padding: 10px;">{{ $t('page_compound.info') }}</h3>
          <hr class="printShow">
          <v-list two-line class="display-flex" dense>
            <v-subheader class="printNone"><h3>{{ $t('page_compound.info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.compound_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.compound_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.compound_date | dateTime }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.compound_date') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-list fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t(`page_compound.${data.compound_type}`) | capitalize }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.compound_type') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width25">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-home fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2" style="font-weight: bold;">{{ $t(`page_compound.${data.status}`) | uppercase }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.status') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <br class="printNone">
          <v-list two-line dense>
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_compound.owner_info') }}</h3>
            <hr class="printShow">
            <v-subheader class="printNone"><h3>{{ $t('page_compound.owner_info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content v-if="data.compound_type === 'city_control' || data.compound_type === 'individual' || data.compound_type === 'health_individual' || data.compound_type === 'vehicle'">
                <v-list-item-title class="body-2">{{ hideText(data.name) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.name') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="data.compound_type === 'trading' || data.compound_type === 'health_trading'">
                <v-list-item-title class="body-2">{{ hideText(data.company_name) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.company_name') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content v-if="data.compound_type === 'city_control' || data.compound_type === 'individual' || data.compound_type === 'health_individual'">
                <v-list-item-title class="body-2">{{ hideIC(data.ic_no) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.ic_no') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="data.compound_type === 'trading' || data.compound_type === 'health_trading'">
                <v-list-item-title class="body-2">{{ data.trading_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.trading_no') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="data.compound_type === 'vehicle'">
                <v-list-item-title class="body-2">{{ data.vehicle_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.vehicle_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.compound_type === 'city_control' || data.compound_type === 'individual' || data.compound_type === 'health_individual'">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-address-card fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ hideIC(data.passport_no) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.passport_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list three-line dense>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-map-marker fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <textarea :value="data.location" style="width: 100%" class="printNone" disabled/>
                <span class="printShow">{{ data.location }}</span>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.location') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-gavel fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <textarea :value="data.bylaw" style="width: 100%" class="printNone" disabled/>
                <span class="printShow">{{ data.bylaw }}</span>
                <v-list-item-subtitle class="body-2">{{ $t('page_compound.bylaw') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-flag fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <textarea :value="data.offence" style="width: 100%" class="printNone" disabled/>
                <span class="printShow">{{ data.offence }}</span>
                <v-list-item-subtitle class="body-2" style="padding-bottom: 10px">{{ $t('page_compound.offence') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs12 sm6 :pt-3="$vuetify.breakpoint.xsOnly">
          <v-layout column :pl-3="$vuetify.breakpoint.smAndUp">
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_compound.payment_info') }}</h3>
            <hr class="printShow">
            <v-list two-line class="display-flex" dense>
              <v-subheader class="printNone"><h3>{{ $t('page_compound.payment_info') }}</h3></v-subheader>
              <v-divider class="printNone"/>
              <v-list-item v-if="data.status === 'PAID'" class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ data.receiptdate.substring(6) + "-" + data.receiptdate.substring(4, 6) + "-" + data.receiptdate.substring(0, 4) }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('page_compound.receiptdate') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="data.status === 'PAID'" class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ data.receiptno }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('page_compound.receiptno') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="data.discount > 0" class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-dollar fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="body-2 elevation-0">{{ data.discount | currency('RM ') }}</v-card>
                  <v-list-item-subtitle class="body-2">{{ $t('page_compound.discount') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list three-line class="display-flex marginBottom40" dense>
              <v-list-item class="width25">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="title elevation-0"><strong>{{ data.amount | currency('RM ') }}</strong></v-card>
                  <v-list-item-subtitle class="body-2"><strong>{{ $t('page_compound.amount') }}</strong></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <span class="text-center caption printShow pt-4">*Slip ini merupakan salinan tidak rasmi untuk rujukan peribadi sahaja.*</span>
            <span class="text-center caption printShow">Tarikh: {{ new Date().toLocaleString('en-GB') }}, Dicetak oleh: {{ username + ' @ App e-Services MPT' }} </span>
            <v-layout mt-2 class="printNone">
              <div class="row justify-end text-center">
                <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                  <v-btn :block="$vuetify.breakpoint.xsOnly" color="teal" class="white--text" large rounded @click="payOnline(data)" :disabled="data.status === 'PAID'">{{ $t('page_compound.pay_online') }}</v-btn>
                </v-col>
                <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                  <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" large rounded @click="print(data)">{{ $t('page_compound.print') }}</v-btn>
                </v-col>
              </div>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import QrcodeVue from 'qrcode.vue'
import configuration from '../../configurations/index'

export default {
  beforeMount () {
    this.fetchData({ id: this.$route.params.id })
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...vuex.mapState({
      data: state => state.search.data,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      url: 'http://services.mptpay.net/' + window.location.hash
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'search/fetchData'
    }),
    hideIC: function (text) {
      var t = text
      var hiddenText = ''
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          if (i < t.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += t[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      var t = text
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    payOnline (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configuration.host.epayment}/#/confirmation?_id=${
          btoa(data._id)
        }&council=mpt&payment_type=compound`
        return
      }
      let ref = cordova.InAppBrowser.open(`${configuration.host.epayment}/#/confirmation?_id=${
        btoa(data._id)
      }&council=mpt&payment_type=compound`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 41) === `${configuration.host.epayment}/#/receipt?`) {
          params = event.url.substring(41, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configuration.host.epayment}/#/index.html#/` || event.url === `${configuration.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))
    },
    print (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.print()
        return
      }
      document.getElementsByTagName('noscript')[0].parentNode.removeChild(document.getElementsByTagName('noscript')[0])
      var page = document.documentElement
      cordova.plugins.printer.print(page, `${data.compound_no}.html`)
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  .v-app-bar {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -80px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25%;
  }
  .marginBottom40 {
    margin-bottom: -40px;
  }
}
</style>
